import { GetterTree } from "vuex";
import { RootState } from "../types";
import { TimeLineInt } from "./types";
export const getters: GetterTree<TimeLineInt, RootState> = {};
